// import * as fn from './utils'
// import StarIcon from '@mui/icons-material/Star';

// export function Testimonials(props:any){

//     const tests = [
//         {name: 'L',text: 'Profissional muito atenciosa e acolhedora, me ajudou muito em minhas questões emocionais e a entender melhor a mim mesma.'},
//         {name: 'T',text: 'Profissional excelente, atenciosa e empática. Gostei muito! Foi uma verdadeira luz quando eu mais precisei. Recomendo a todos.'},
//         {name: 'R',text: 'Psi excelente! Só tenho a agradecer pelo carinho e paciência ao longo dessa jornada, que é a terapia, juntas. 🤍'},


//     ]

//     return(
//         <div style={{width:'100%', justifyContent:'center', alignItems:'center', display:'flex', marginTop:'50px'}}>
//             {tests.map((t, index)=>{
//                 return(
//                     <div style={{
//                 width: '250px',
//                 height: '200px',
//                 backgroundColor: fn.Colors.offWhite2,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between',
//                 padding: '20px',
//                 position: 'relative',
//                 marginLeft:'30px',
//                 boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//                 borderRadius:'5px'
//             }}>
//                 <div style={{fontSize:'100px', fontFamily: '"Fleur De Leah", cursive' , color:fn.Colors.light, position:'absolute', top:'-40px', left:'-30px'}}>
//                     "
//                 </div>
//                 <div style={{fontSize:'100px', fontFamily: '"Fleur De Leah", cursive', color:fn.Colors.light, position:'absolute', bottom:'-20px', right:'0px', lineHeight:'0px'}}>
//                     "
//                 </div>
//                 <div style={{fontSize:'18px', fontFamily:'Inter', fontStyle:'italic'}}>
//                     {t.text}
//                 </div>
//                 <div style={{display:'flex', alignItems:'center', width:'100%'}}>
//                     <div style={{fontWeight:'800', fontSize:'30px'}}>
//                         - {t.name}.
//                     </div>
//                     <div style={{fontSize:'8px', opacity:'0.2', marginLeft:'auto'}}>
//                         <StarIcon style={{ fontSize: 18 }}/>
//                         <StarIcon style={{ fontSize: 18 }}/>
//                         <StarIcon style={{ fontSize: 18 }}/>
//                         <StarIcon style={{ fontSize: 18 }}/>
//                         <StarIcon style={{ fontSize: 18 }}/>

//                     </div>
//                 </div>
                
//             </div>
//                 )
//             })}
            
//         </div>
//     )
// }

import * as fn from './utils'
import StarIcon from '@mui/icons-material/Star';
import { useEffect, useState } from 'react';

export function Testimonials(props: any) {

    const tests = [
        {
            name: 'L',
            text: 'Profissional muito atenciosa e acolhedora, me ajudou muito em minhas questões emocionais e a entender melhor a mim mesma.'
        },
        {
            name: 'T',
            text: 'Profissional excelente, atenciosa e empática. Gostei muito! Foi uma verdadeira luz quando eu mais precisei. Recomendo a todos.'
        },
        {
            name: 'R',
            text: 'Psi excelente! Só tenho a agradecer pelo carinho e paciência ao longo dessa jornada, que é a terapia, juntas. 🤍'
        }
    ]

    return (
        <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '50px'
        }}>

            {/* DESKTOP */}
            {!props.mobile && (
                <div style={{ display: 'flex' }}>
                    {tests.map((t, index) => (
                        <Card key={index} t={t} />
                    ))}
                </div>
            )}

            {/* MOBILE */}
            {props.mobile && (
                <MobileCarousel tests={tests} />
            )}

        </div>
    )
}

/* ---------------- CARD ---------------- */

function Card({ t }: any) {
    return (
        <div style={{
            width: '250px',
            height: '200px',
            backgroundColor: fn.Colors.offWhite2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: '20px',
            position: 'relative',
            marginLeft: '20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            borderRadius: '6px',
        }}>

            {/* ASPAS ESQUERDA */}
            <div style={{
                fontSize: '100px',
                fontFamily: '"Fleur De Leah", cursive',
                color: fn.Colors.light,
                position: 'absolute',
                top: 0,
                left: 0,
                transform: 'translate(-25px, 25px)',
                lineHeight:0
            }}>
                "
            </div>

            {/* ASPAS DIREITA */}
            <div style={{
                fontSize: '100px',
                fontFamily: '"Fleur De Leah", cursive',
                color: fn.Colors.light,
                position: 'absolute',
                bottom: 0,
                right: 0,
                transform: 'translate(0px, 20px)',
                lineHeight:0

            }}>
                "
            </div>

            {/* TEXTO */}
            <div style={{
                fontSize: '18px',
                fontFamily: 'Inter',
                fontStyle: 'italic',
                zIndex: 2
            }}>
                {t.text}
            </div>

            {/* FOOTER */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                zIndex: 2
            }}>

                <div style={{ fontWeight: 800, fontSize: '28px' }}>
                    - {t.name}.
                </div>

                <div style={{
                    marginLeft: 'auto',
                    display: 'flex',
                    opacity: 0.3
                }}>
                    <StarIcon style={{ fontSize: 16 }} />
                    <StarIcon style={{ fontSize: 16 }} />
                    <StarIcon style={{ fontSize: 16 }} />
                    <StarIcon style={{ fontSize: 16 }} />
                    <StarIcon style={{ fontSize: 16 }} />
                </div>

            </div>

        </div>
    )
}

/* ---------------- MOBILE CAROUSEL ---------------- */

function MobileCarousel({ tests }: any) {

    const [index, setIndex] = useState(0)
    const [animating, setAnimating] = useState(false)

    useEffect(() => {
        const interval = setInterval(() => {
            setAnimating(true)

            setTimeout(() => {
                setIndex((prev) => (prev + 1) % tests.length)
                setAnimating(false)
            }, 250)

        }, 7000)

        return () => clearInterval(interval)
    }, [tests.length])

    const current = tests[index]

    return (
        <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        }}>
            <div style={{ position: 'relative' }}>

                <div style={{
                    transform: animating ? 'translateX(-120%)' : 'translateX(0)',
                    transition: 'transform 250ms ease'
                }}>
                    <Card t={current} />
                </div>

            </div>
        </div>
    )
}